import MemberJoinedAlert from './MemberJoinedAlert';

export default MemberJoinedAlert;
export type { Props } from './types';
